import { HeaderType } from "../../components/Header/Header";

const fixture = {
  type: HeaderType.WHITE,
  isAuthenticated: false,
};

export default fixture;
